import { useEffect } from 'react';
import { useGoToBootstrap } from 'modules/navigation';

const GoToPage = () => {
  const { redirect } = useGoToBootstrap();

  useEffect(() => {
    redirect();
  }, []);

  return <></>;
};

export default GoToPage;
